module.exports = __webpack_public_path__ + "img/JoinUs.33e2fa41.png";